import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import InputWindow from 'Flow2/components/UI/Overlay/InputWindow';

import Button from 'Flow2/components/UI/Button/Button';
import Input from 'Flow2/components/UI/Input/Input';
import TagTree from 'Flow2/components/Article/Tags/TagTree';
import SM from 'Flow2/util/StructureMapping.js';

import * as actions from 'store/actions/index';

import classes from './TagTreeDynamic.module.scss';

const FILTER_TAG_TREE = "FILTER_TAG_TREE";

export class StockWindow extends Component {
    constructor(props) {
        super(props);
        this.state = StockWindow.initState(props);
    }
    
    static initState(props) {
        const state = {};
  
        state.filter = {};
        state.tags = props.selected || [];
        state.keywords = props.keywords || [];
        
        return state;
    }

	static getDerivedStateFromProps(props, state) {
        return null;
    }
    
    componentDidMount() {}
    
    componentDidUpdate(prevProps, prevState) {}
    
    componentWillUnmount() {}
    
    onCancel = () => {
        this.props.onClose();
    }
    
    onSave = () => {
        //this.props.onSetupFields(this.state.checked);
        if(this.props.changeHandler) {
            this.props.changeHandler({
                keywords: this.state.keywords,
                tags: this.state.tags
            });
            
        }
        this.props.onClose();
    }
    
    onFilterChanged = (filter, value) => {
        let filters = this.state.filter;
        filters[filter] = value;
        this.setState({ filter: filters });
    }

    getFilter = (filter) => {
        return (
            <FlexRow className={classes.Filter}>
                <Input
                    className={'fullWidth'}
                    key={filter}
                    value={this.state.filter[filter] || ""}
                    elementConfig={{ type: 'text', placeholder: 'Filter' }}
                    changed={(event) => {
                        this.onFilterChanged(filter, event.target.value);
                    }}
                />
            </FlexRow>
        );
    }
    
    onLoaded = (tags = [], keywords = []) => {
        //console.log(tags, keywords);
        this.props.onLoaded && this.props.onLoaded(tags, keywords);
    }
    
    onSelect = (tags = [], keywords = []) => {
        //console.log(tags, keywords);
        this.props.onSelect && this.props.onSelect(tags, keywords);
        this.setState({ tags: tags, keywords: keywords });
    }
	
	renderContent =  () => {
        return (
            <div className={[classes.WindowContent, "fullWidth"].join(' ')}>
                <TagTree
                    title={this.props.config.TAG_TREE_TITLE}
                    selected={this.state.tags}
                    keywords={this.state.keywords}
                    onSelect={this.onSelect}
                    onLoaded={this.onLoaded}
                    singleSelect={this.props.singleSelect || false}
                    extraContent={this.getFilter(FILTER_TAG_TREE)}
                    filter={{ field: 'name', search: this.state.filter[FILTER_TAG_TREE] }} />
            </div>
        )
    }
    
    render = () => {
        return(
			<InputWindow 
                show={this.props.show} 
                content={this.renderContent()}
                title="Bestände"
                onSave={this.onSave}
                onCancel={this.props.onClose}/>
        )
    }
}

//const ListHeader = (props) => {
class TagTreeDynamic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }
    
    onShow = () => {
       this.setState({ show: true }); 
    }
    
    onClose = () => {
        this.setState({ show: false }); 
    }
    
    
	render() {
        const element = this.props.element;
        const values = typeof element.value === 'string' ? element.value.split(';') : [];
        const ids = typeof this.props.ids === 'string' ? this.props.ids.split(';') : [];
        
        return (
            <>
            <FlexRow className={[classes.Input,"fullWidth"].join(' ')}>
                <Input
                    key={element.id}
                    value={values.join('; ')}
                    elementConfig={{ type: 'text', placeholder: SM.hasPlaceholder(element.obj) || "", readonly: true }}
                    changed={null}
                />
				<Button
                    key="ok"
                    btnType="Red"
                    clicked={this.onShow}>
                    <FontAwesomeIcon icon={faPen} className={['pointer'].join(' ')} title={this.props.intl.formatMessage({ id: "common.edit" })} />
                </Button>
			</FlexRow>
			{ this.state.show ?
                <StockWindow 
                    {...this.props} 
                    show={this.state.show} 
                    onClose={this.onClose}
                    selected={ids}
                    keywords={values}
                    singleSelect={true}
                    changeHandler={(values) => {
                        this.props.changeHandler({
                            [element.id]: values.keywords.join(';'),
                            [this.props.reference]: values.tags.join(';')
                        });
                    }}
                />
                : ""
            }
            </>
        );
    }
};


const mapStateToProps = (state) => {
	return {
        config: state.ui.config
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TagTreeDynamic));
